import { useRef, memo } from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { langTimeSpeedChart } from '../assets/langTimeSpeedChart'
import { useLang } from '../utils/hooks'

const TimeSpeedChart = ({ speedRanges, type }) => {
  const { lang } = useLang()
  const choosenLang =
    lang === 'fr' ? langTimeSpeedChart.fr : langTimeSpeedChart.eng

  const options = {
    chart: {
      backgroundColor: 'transparent',
      type: 'column',
      height: 200,
    },
    title: {
      text:
        type === 'time'
          ? choosenLang.timeChartTitle
          : choosenLang.distanceChartTitle,
      style: {
        fontSize: '10px',
        fontWeight: 'bold',
      },
      verticalAlign: 'bottom',
    },
    tooltip: {
      pointFormat: '<b>{point.y:.0f}%</b>',
    },
    accessibility: {
      point: {
        valueSuffix: '%',
      },
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      series: {
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          format: '{point.y:.0f} %',
        },
      },
    },
    xAxis: {
      type: 'category',
    },
    yAxis: {
      title: '',
    },
    series: [
      {
        name: 'Vitesse',
        colorByPoint: true,
        data: [
          {
            name: '3 - 10',
            y: speedRanges.inf10,
          },
          {
            name: '10 - 15',
            y: speedRanges.sup10,
          },
          {
            name: '15 - 20',
            y: speedRanges.sup15,
          },
          {
            name: '20 - 25',
            y: speedRanges.sup20,
          },
          {
            name: '25 - 30',
            y: speedRanges.sup25,
          },
          {
            name: '> 30',
            y: speedRanges.sup30,
          },
        ],
      },
    ],
  }
  const chart = useRef(null)
  return (
    <div style={{ maxWidth: '800px' }}>
      <HighchartsReact ref={chart} highcharts={Highcharts} options={options} />
    </div>
  )
}

export default memo(TimeSpeedChart)
